module.exports = __webpack_public_path__ + "static/media/UserManagement.5a6cc6ba.png";